import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);

var $investments = $('.investments .investments-wrapper .tease');

if ($investments.length > 0 && $(window).width() >= 1024) {
    $investments.hover(function () {
        let $this = $(this);
    /*     $('.tease-investment.set-opacity').css({
            'filter': 'blur(2px)'
        }); */
        $this.css({
            'opacity': '1',
            'transition': 'opacity 0.3s cubic-bezier(0.645, 0.045, 0.355, 1), transform 0.4s cubic-bezier(0.645, 0.045, 0.355, 1), filter 0.3s cubic-bezier(0.645, 0.045, 0.355, 1)',
            'transform': 'translate(0, 0) scale(1.015)',
            'filter': 'blur(0)'
        });
    }, function() {
        let $this = $(this);
        $('.tease-investment.set-opacity').css({
            'opacity': '1',
            'filter': 'blur(0)'
        });
        $this.css({
            'opacity': '1',
            'transform': 'translate(0, 0) scale(1)'
        });
        setTimeout(function() {
            $this.css({
                'transition': 'opacity 0.3s cubic-bezier(0.645, 0.045, 0.355, 1), filter 0.3s cubic-bezier(0.645, 0.045, 0.355, 1)'
            });
        }, 300);
    });
}

ScrollTrigger.batch(".investments-wrapper .tease.show", {
    interval: 0.1, // time window (in seconds) for batching to occur. The first callback that occurs (of its type) will start the timer, and when it elapses, any other similar callbacks for other targets will be batched into an array and fed to the callback. Default is 0.1
    batchMax: 4,   // maximum batch size (targets)
    start: "top-=50 bottom",
    onEnter: (batch) => {
        gsap.to(batch, {y: 0, autoAlpha: 1, stagger: 0.15, overwrite: true});
        for (let i=0; i < batch.length; i++) {
            batch[i].classList.add('set-opacity');
        }
      },
    ease: 'power1',
    once: true
  });